import { BILLING_CYCLE } from "../constants";
import { isEmptyVal } from '@/utils';
import  { planTypes } from "@/common/constants";
import { SMB_BILLING_CYCLE_MAP } from '@/common/service/non-standard-billing-cycle-utils';
import { sortBy } from "lodash";

export function getCartInfo() {
  return { selected_number: 0, add_time: null };
}

export const defaultMapper = (payload, type, disablePlanCodeList = []) => {
  if (isEmptyVal(payload)) {
    return [];
  }

  const {
    month_plancode,
    month_amount,
    month_hide,
    month_plantype,
    yearly_plancode,
    yearly_amount,
    yearly_hide,
    yearly_plantype,
    category,
    parent_category,
    old_plan_code,
    one_month_plancode,
    one_month_hide,
    quarterly_plancode,
    quarterly_plantype,
    quarterly_hide,
    quarterly_amount,
    two_years_plancode,
    two_years_plantype,
    two_years_hide,
    two_years_amount,
    three_years_plancode,
    three_years_plantype,
    three_years_hide,
    three_years_amount,
    typeNameKey = '',
    dependBasePlanTypeList = [],
    billingCycleDependBasePlanTypeList = [],
  } = payload;
  const result = [];
  if (one_month_plancode && !one_month_hide && !disablePlanCodeList.includes(one_month_plancode)) {
    result.push({
      type,
      category,
      parent_category,
      plan_code: one_month_plancode,
      cartInfo: getCartInfo(),
      amount: month_amount,
      billing_cycle: BILLING_CYCLE.ONE_MONTH,
      old_plan_code,
      isOneMonth: true,
      mapping_plan_code: month_plancode, // in order to find monthly plan
      dependBasePlanTypeList,
      billingCycleDependBasePlanTypeList,
      supportCoupon: true,
      typeNameKey,
    });
  }

  if (month_plancode && !month_hide && !disablePlanCodeList.includes(month_plancode)) {
    result.push({
      type,
      category,
      parent_category,
      plan_code: month_plancode,
      plan_type: month_plantype,
      cartInfo: getCartInfo(),
      amount: month_amount,
      billing_cycle: BILLING_CYCLE.MONTHLY,
      old_plan_code,
      mapping_plan_code: one_month_plancode, // in order to find one month plan
      dependBasePlanTypeList,
      billingCycleDependBasePlanTypeList,
      supportCoupon: true,
      typeNameKey,
    });
  }
  if (yearly_plancode && !yearly_hide && !disablePlanCodeList.includes(yearly_plancode)) {
    result.push({
      type,
      category,
      parent_category,
      plan_code: yearly_plancode,
      plan_type: yearly_plantype,
      amount: yearly_amount,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.ANNUAL,
      old_plan_code,
      dependBasePlanTypeList,
      billingCycleDependBasePlanTypeList,
      supportCoupon: true,
      typeNameKey,
    });
  }

  if (quarterly_plancode && !quarterly_hide && !disablePlanCodeList.includes(quarterly_plancode)) {
    result.push({
      type,
      category,
      parent_category,
      plan_code: quarterly_plancode,
      plan_type: quarterly_plantype,
      amount: quarterly_amount,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.QUARTERLY,
      old_plan_code,
      dependBasePlanTypeList,
      billingCycleDependBasePlanTypeList,
      supportCoupon: true,
      typeNameKey,
    });
  }
  if (two_years_plancode && !two_years_hide && !disablePlanCodeList.includes(two_years_plancode)) {
    result.push({
      type,
      category,
      parent_category,
      plan_code: two_years_plancode,
      plan_type: two_years_plantype,
      amount: two_years_amount,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.TWO_YEARS,
      old_plan_code,
      dependBasePlanTypeList,
      billingCycleDependBasePlanTypeList,
      supportCoupon: true,
      typeNameKey,
    });
  }
  if (three_years_plancode && !three_years_hide && !disablePlanCodeList.includes(three_years_plancode)) {
    result.push({
      type,
      category,
      parent_category,
      plan_code: three_years_plancode,
      plan_type: three_years_plantype,
      amount: three_years_amount,
      cartInfo: getCartInfo(),
      billing_cycle: BILLING_CYCLE.THREE_YEARS,
      old_plan_code,
      dependBasePlanTypeList,
      billingCycleDependBasePlanTypeList,
      supportCoupon: true,
      typeNameKey,
    });
  }

  if(type === planTypes.VIDEO_SDK){
    const { plancode ,amount , billing_cycle } = payload;
    const billingCycle = (+amount) === 0 ? BILLING_CYCLE.PAY_AS_YOU_GO : billing_cycle;
    result.push({
      type,
      category,
      amount,
      parent_category,
      plan_code: plancode,
      cartInfo: getCartInfo(),
      billing_cycle: billingCycle,
      supportCoupon: false,
      typeNameKey,
      dependBasePlanTypeList,
    });
  }
  return sortBy(result, ({ billing_cycle }) => SMB_BILLING_CYCLE_MAP[billing_cycle]?.index ?? 0);
}
